"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountOwner = void 0;
var getCountOwner = function (count) {
    return count > 5 ? "".concat(count, " \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432") : count > 1 ? "".concat(count, " \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430") : "".concat(count, " \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446");
};
exports.getCountOwner = getCountOwner;
